export enum Colors {
	RED = 'RED',
	BLUE = 'BLUE',
	ORANGE = 'ORANGE',
	PINK = 'PINK',
	GRAY = 'GRAY',
	YELLOW = 'YELLOW'
}
